import { g as l } from "./_commonjsHelpers-DaMA6jEr.js";
import { r as s } from "./_baseClone-DlnNbwlz.js";
var e, r;
function u() {
  if (r) return e;
  r = 1;
  var o = s(), n = 1, t = 4;
  function a(p) {
    return o(p, n | t);
  }
  return e = a, e;
}
var c = u();
const C = /* @__PURE__ */ l(c);
export {
  C as c
};
